/**
 * English mirror of ./strings.ar.js — GENERATED by scripts/i18n/build.mjs.
 *
 * Wording follows the legacy Locale/*.resx English resources wherever the
 * legacy screen had the same label. To change any of it, edit
 * scripts/i18n/strings.en.json and re-run the script.
 */

const shared = {
  setPeriod: 'Set Period',

  from: 'From',
  to: 'To',
  getReport: 'Get report',
  active: 'Active',
  inactive: 'Disabled',
  edit: 'Update',
  delete: 'Delete',
  addNew: 'Add New',
  close: 'Close',
}

export const transactionsStrings = {
  ...shared,
  title: 'Transactions',
  subtitle: 'Every point awarded or deducted, when and why',
  empty: 'No transactions in this period',
  actionFailed: 'The log could not be loaded',
  fail: {
    list: 'Could not load the points log',
  },

  positive: 'Positive',
  negative: 'Negative',

  columns: {
    activity: 'Activity name',
    user: 'Username',
    timestamp: 'Date',
    points: 'Points',
    percentage: 'Percentage On Duplication',
    type: 'Points Type',
    opposite: 'Effect Opposite?',
    resetDate: 'Reset Date',
  },
}

export const resetLogsStrings = {
  ...shared,
  title: 'Points Reset Logs',
  subtitle: 'Every time participant points were cleared and a new period began',
  empty: 'Points have not been reset yet',
  actionFailed: 'The reset log could not be loaded',
  fail: {
    list: 'Could not load the points resets',
    create: 'Could not run the points reset',
  },

  columns: {
    timestamp: 'Date',
    user: 'Username',
    notes: 'Notes',
  },

  viewTransactions: 'Transactions',

  create: 'Reset everyone\'s points',
  createTitle: 'Reset everyone\'s points?',
  createConfirm: 'Every participant’s balance will be cleared and a new period will begin. Past transactions stay in the log, and this cannot be undone.',
  created: 'Points were reset and a new period has begun',
  notesHint: 'Why you are resetting — the only thing recorded about this operation',
}

export const analysisStrings = {
  ...shared,
  title: 'Results',
  subtitle: 'Where the organisation stands, and how its people spread across the risk levels',
  empty: 'No matching participants',
  actionFailed: 'The results could not be loaded',
  // See the note in strings.ar.js.
  fail: {
    page: 'Could not load the points analysis page',
    report: 'Could not load the points report for this period',
    list: 'Could not load the user ranking',
  },

  pointsType: 'Ranked by',
  positive: 'Positive points',
  negative: 'Negative points',

  allTime: 'All time',
  period: 'Period',
  spread: 'How participants spread',
  organizationRisk: 'Organisation risk level',
  bandUsers: 'participants',

  columns: {
    userName: 'Username',
    name: 'Name',
    department: 'Group',
    positive: 'Positive Total Points',
    negative: 'Negative Total Points',
    riskLevel: 'Risk Level',
    badges: 'Badges',
  },

  summary: {
    caption: 'Results at a glance',
    people: 'Participants',
    positive: 'Total positive points',
    negative: 'Total negative points',
    average: 'Average negative points per participant',
  },
}

export const gamificationSettingsStrings = {
  ...shared,
  title: 'Settings',
  subtitle: 'Gamification',

  actionFailed: 'The operation could not be completed',
  fail: {
    page: 'Could not load the gamification settings',
    list: 'Could not load the list',
    save: 'Could not save the item',
    settings: 'Could not save the gamification settings',
    badges: 'Could not save the badge awarding settings',
  },
  saved: 'Saved successfully',
  save: 'Save',
  required: 'Field required',
  nameAr: 'Arabic Name',
  nameEn: 'English Name',
  descriptionAr: 'Arabic Description',
  descriptionEn: 'English Description',

  settings: {
    tab: 'Gamification settings',
    enabled: 'Enable gamification',
    enabledHint: 'While off, no points are counted and no badges are awarded',
    notifications: 'Gamification notifications',
    notificationsHint: 'Tell a user when they earn points or a badge',
    leaderBoard: 'Leaderboard',
    showLeaderBoard: 'Show the leaderboard to users',
    topUsersOnlyWithBadges: 'Only show users who hold a badge',
    leaderBoardNameAr: 'Arabic screen name',
    leaderBoardNameEn: 'English screen name',
    leaderBoardUsersCount: 'How many users to show',
    leaderBoardUsersCountHint: 'Leave it empty to show everyone',
    leaderBoardUsersCountEveryone: 'Everyone',
    leaderBoardUsersCountError: (max) => `Enter a number from 1 to ${max}, or leave it empty to show everyone`,
  },

  activityForm: {
    add: 'New activity',
    edit: 'Edit activity',
    eventType: 'Activity name',
    points: 'Points',
    isPositive: 'Positive points',
    isPositiveHint: 'While off, the points are deducted rather than awarded',
    effectOpposite: 'Cancels the opposite activity',
    percentage: 'Percentage on repeat (%)',
    percentageHint: 'Leave empty if a repeat earns the full amount',
    enabled: 'This activity is active',
    empty: 'No activities yet',
    examNote: 'Passing a test awards points from the test score, not a fixed number.',
  },

  badgeForm: {
    add: 'New badge',
    edit: 'Edit badge',
    points: 'Points needed',
    image: 'Badge image',
    imageHint: 'A square PNG',
    enabled: 'This badge is active',
    empty: 'No badges yet',
    awarding: 'How badges are shown',
    awardingHint: 'What appears on a user profile',
    awardingAll: 'Every badge earned',
    awardingLast: 'The most recent badge only',
    awardingSaved: 'Badge display updated',
  },

  riskForm: {
    add: 'New level',
    edit: 'Edit level',
    min: 'Min Level',
    max: 'Max Level',
    maxHint: 'Leave empty for an open-ended top band',
    openEnded: 'No ceiling',
    enabled: 'This level is active',
    empty: 'No risk levels yet',
  },

  tabs: {
    settings: 'Gamification settings',
    activities: 'Activities',
    badges: 'Badges',
    riskLevels: 'Risk Levels',
  },

  activities: {
    name: 'Activity name',
    points: 'Points',
    percentage: 'Percentage On Duplication',
    type: 'Points Type',
    opposite: 'Effect Opposite?',
    status: 'Active',
  },

  badges: {
    name: 'Name',
    points: 'Positive points',
    description: 'Description',
    status: 'Active',
  },

  riskLevels: {
    name: 'Name',
    min: 'Minimum (negative points)',
    max: 'Maximum (negative points)',
    status: 'Active',
  },

  deleteConfirm: 'Delete this entry?',

  deleted: 'Operation Completed Successfully',
}
